import React from "react";

import { Text } from "@performyard/py-components";

type Props = {
	companyName: string;
};

const HeaderRow: React.FC<Props> = ({ companyName }) => {
	return (
		<div className="flex flex-col">
			<Text size="paragraph-1" dangerouslySetClassName="text-[28px] font-semibold leading-10 text-neutral-9">
				{companyName}
			</Text>
			<Text size="paragraph-2" dangerouslySetClassName="leading-6 text-neutral-9">
				Manage your company settings
			</Text>
		</div>
	);
};

export default HeaderRow;
